import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import Robinson from "./components/Home/Home";
import styled, { ThemeProvider } from "styled-components";
import theme from "./webConfigs/theme";

const Styled = styled.div`
  @font-face {
    font-family: "CPN";
    font-weight: normal;
    font-style: normal;
    src: url("/fonts/CPN-Regular.eot");
    src: url("/fonts/CPN-Regular.eot?#iefix") format("embedded-opentype"),
      url("/fonts/CPN-Regular.woff2") format("woff2"),
      url("/fonts/CPN-Regular.woff") format("woff"),
      url("/fonts/CPN-Regular.ttf") format("truetype"),
      url("/fonts/CPN-Regular.svg#CPN-Regular") format("svg");
  }
  @font-face {
    font-family: "CPN";
    font-weight: bold;
    font-style: normal;
    src: url("/fonts/CPN-Bold.eot");
    src: url("/fonts/CPN-Bold.eot?#iefix") format("embedded-opentype"),
      url("/fonts/CPN-Bold.woff2") format("woff2"),
      url("/fonts/CPN-Bold.woff") format("woff"),
      url("/fonts/CPN-Bold.ttf") format("truetype"),
      url("/fonts/CPN-Bold.svg#CPN-Bold") format("svg");
  }

  font-family: "CPN";
`;

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme.styles}>
      <div id="layout">
        <Styled>
          <Robinson />
        </Styled>
      </div>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
